// src/data/stockItems.ts
// ----------------------
// Repository for `stock_items` — the admin-editable Bulk Stationery catalogue, the
// ONLY editable section of a Stock Top-up (db-155). The Stock Top-up form reads the
// active list for its Bulk section. Typed via getTypedClient().

import { logger } from "../utils/logger";
import { getTypedClient } from "../utils/supabase";

export interface StockItemRow {
  id: string;
  name: string;
  pack_size: number;
  max_qty: number;
  sort_order: number;
  deactivated: boolean;
}

// Typed as `string` (not a literal) so supabase-js doesn't deep-parse the select.
const STOCK_ITEM_COLS: string = "id, name, pack_size, max_qty, sort_order, deactivated";

// The Bulk Stationery catalogue, sort_order-ordered. Active only by default (what
// the Stock Top-up Bulk section renders); pass includeDeactivated=true for a future
// admin view. Small table, so a plain limit is plenty. Returns [] on error / no
// client (the form then shows an empty Bulk section rather than crashing).
export async function listStockItems(includeDeactivated = false): Promise<StockItemRow[]> {
  const c = getTypedClient();
  if (!c) return [];
  let q = c.from("stock_items").select(STOCK_ITEM_COLS);
  if (!includeDeactivated) q = q.eq("deactivated", false);
  const { data, error } = await q.order("sort_order").limit(200);
  if (error) {
    logger.warn("listStockItems failed:", error.message);
    return [];
  }
  return (data ?? []) as unknown as StockItemRow[];
}
